export default {
  user: {},
  token: null
}
